var classnames = { exports: {} };
export {
  classnames as __module
};
//# sourceMappingURL=index2.js.map
